import { EventrDate, IEventrActivity } from '@eventr/common'
import React, { useMemo } from 'react'
import { useGlobalRouter } from '../../feat/globalRouter/useGlobalRouter'
import { useScreenTypeContext } from '../state/screenTypeProvider'
import { ActivityBookingInfo } from './activityComponents/activityBookingInfo'
import { ActivityDate } from './activityComponents/activityDate'
import { ActivityDescription } from './activityComponents/activityDescription'
import { ActivityExtraInfo } from './activityComponents/activityExtraInfo'
import { ActivityHeader } from './activityComponents/activityHeader'
import { ActivityImage } from './activityComponents/activityImage'
import { EventTimeRow } from './activityComponents/eventTimeRow'
import { useGetCategory } from './hooks/useGetCategory'
import { ObjectProvider } from './providers/objectProvider'
import { BaseCard } from './subComponents/baseCard'
import { DraftMessage } from './subComponents/draftMessage'

interface IActivityCardProps {
    id?: string
    data?: IEventrActivity
    past?: boolean
}

export const ActivityCard: React.FC<IActivityCardProps> = ({ id, data }) => {
    const { screenType } = useScreenTypeContext()

    const mainCategory = useGetCategory(data?.categories?.[0])
    const { pushPath } = useGlobalRouter()
    const attachments = {
        notes: data?.additional_information,
        extra_docs: data?.documents,
        website: data?.website,
    }
    const isPast = useMemo(() => {
        if (data?.end) {
            return new EventrDate(data.end).getUnixMs < new Date().getTime()
        }
        if (!data?.end && data?.start) {
            return new EventrDate(data.start).getUnixMs < new Date().getTime()
        }
        return false
    }, [data])

    if (!data) return null

    const activityExtraSection = (
        <ActivityExtraInfo location={data.location} address={data.address} />
    )
    const activityTimes = <EventTimeRow start={data.start} end={data.end} />

    return (
        <ObjectProvider
            past={isPast}
            _id={data._id}
            sectionID="8"
            visibility={data.visibility}
        >
            <BaseCard
                onClick={() => {
                    if (screenType === 'edit') {
                        return
                    }
                    pushPath(`/item/activity/${data._id}`)
                }}
                id={id}
                past={isPast}
            >
                {screenType === 'upNext' || screenType === 'personal' ? (
                    <>
                        <ActivityImage
                            images={data.cardImages ?? []}
                            isAdvance={data.isAdvance}
                        />
                        <ActivityHeader
                            visibility={data.visibility}
                            activityName={data.activity_name}
                            label={data.label}
                            labelTime={data.labelTime}
                            start={data.start}
                            end={data.end}
                            icon={mainCategory?.icon}
                        />
                        <ActivityDescription
                            description={data.description ?? ''}
                        />
                        {activityTimes}
                        {activityExtraSection}
                        {/* {activityBookingSection} */}
                    </>
                ) : screenType === 'edit' ? (
                    <>
                        <ActivityDate
                            name={data.activity_name}
                            date={data.start}
                        />
                        {activityTimes}
                        {activityExtraSection}
                        <ActivityBookingInfo
                            chatNames={[data.activity_name ?? '']}
                            attendess={data.attendees_list}
                            attachments={attachments}
                        />
                    </>
                ) : screenType === 'team' || screenType === 'teamMember' ? (
                    <>
                        <ActivityDate
                            name={data.activity_name}
                            date={data.start}
                        />
                        {activityTimes}
                        {activityExtraSection}
                        <ActivityBookingInfo
                            chatNames={[data.activity_name ?? '']}
                            attendess={data.attendees_list}
                            attachments={attachments}
                        />
                    </>
                ) : null}
                <DraftMessage data={data} />
            </BaseCard>
        </ObjectProvider>
    )
}
